import LegalLayout from '@/pages/legal/components/LegalLayout';

export default function PrivacyPolicy() {
  return (
    <LegalLayout title="Privacy Policy" lastUpdated="May 2026" current="/privacy">
      <p>
        Sapphire Media Group ("Sapphire," "we," "us") is a youth-led non-profit fiscally
        sponsored by The Hack Foundation, a U.S. 501(c)(3). This policy describes what
        information we collect when you use this website or interact with our services, why
        we collect it, and what your choices are.
      </p>

      <h2>What we collect</h2>
      <p>
        This site is intentionally close to a static brochure. We do not require accounts,
        and we do not run third-party analytics or advertising trackers. The data we
        receive falls into a few narrow categories:
      </p>
      <ul>
        <li>
          <strong>Server logs.</strong> Our hosting provider records standard web request
          data (IP address, user agent, requested URL, timestamp) for security and
          reliability. These logs are retained for a short period and then discarded.
        </li>
        <li>
          <strong>Email you send us.</strong> If you email{' '}
          <a href="mailto:hello@sapphiremedia.group">hello@sapphiremedia.group</a>, we
          receive whatever you write, your name, and your address. We use it to reply to
          you.
        </li>
        <li>
          <strong>Donations.</strong> Donations are processed by The Hack Foundation
          through their HCB platform. We do not receive your card or banking details — only
          a record of the donation. See{' '}
          <a href="https://hackclub.com/fiscal-sponsorship/" target="_blank" rel="noopener noreferrer">
            HCB's privacy practices
          </a>{' '}
          for details.
        </li>
        <li>
          <strong>Discord.</strong> If you join our Discord server, Discord's privacy
          policy applies to your activity there. We can see your Discord username and
          messages in our server, the same as any other member.
        </li>
      </ul>

      <h2>Cookies</h2>
      <p>
        This site does not set cookies for tracking or advertising. Your browser may store
        small technical items (such as preferred language) locally; these never leave your
        device.
      </p>

      <h2>Children's privacy</h2>
      <p>
        Sapphire is run by and for young people. Many of our contributors are under 18.
        If you are under 13, please ask a parent or guardian before emailing us and please refrain from joining
        the Discord, as that violates Discord’s Terms of Service. We do not knowingly collect personal information from children under
        13 outside the scope needed to respond to a message they have sent us.
      </p>

      <h2>Sharing</h2>
      <p>
        We do not sell or rent personal information. We share information only with our
        fiscal sponsor (The Hack Foundation) when required for accounting or legal
        compliance, with service providers who run our infrastructure (email, hosting), or
        when we are required to by law.
      </p>

      <h2>Your choices</h2>
      <p>
        You can ask us what information we hold about you, ask us to correct it, or ask us
        to delete it, by emailing{' '}
        <a href="mailto:hello@sapphiremedia.group">hello@sapphiremedia.group</a>. Where
        applicable laws (including the GDPR and CCPA) give you specific rights, we honour
        them.
      </p>

      <h2>Changes</h2>
      <p>
        We may update this policy when our practices change. The "last updated" date at
        the top reflects the most recent revision. Material changes will be flagged on the
        site for at least 30 days.
      </p>

      <h2>Contact</h2>
      <p>
        Questions about this policy:{' '}
        <a href="mailto:hello@sapphiremedia.group">hello@sapphiremedia.group</a>.
      </p>
    </LegalLayout>
  );
}
